export default {
  "machine-learning": {
    "passage": "{items, plural, =1 {Réponse} other {Réponses}} {current}/{length, number}",
    "passages": "Réponses",
    "passagesCollapsed": "J'ai trouvé {passagesNb, number} réponses possibles",
    "answers": "Réponses suggérées",
    "answersCollapsed": "J'ai trouvé {answersNb, number} réponses suggérées",
    "answer": "Réponse suggérée"
  }
}